/**
 * Indian national flag, drawn inline as SVG so it renders identically on every
 * platform (emoji flags don't render on Windows at all).
 *
 * Proportions follow the Flag Code of India: 3:2 ratio, three equal bands, and
 * a navy Ashoka Chakra of 24 spokes whose diameter equals the white band.
 */
export default function IndiaFlag({ className = '', title = 'India' }) {
  const spokes = Array.from({ length: 24 }, (_, i) => i * 15);

  return (
    <svg
      viewBox="0 0 90 60"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      <rect width="90" height="20" y="0" fill="#FF9933" />
      <rect width="90" height="20" y="20" fill="#FFFFFF" />
      <rect width="90" height="20" y="40" fill="#138808" />

      {/* Ashoka Chakra — diameter = height of the white band */}
      <g transform="translate(45 30)">
        <circle r="9" fill="none" stroke="#000080" strokeWidth="1" />
        <circle r="1.6" fill="#000080" />
        {spokes.map((deg) => (
          <line
            key={deg}
            x1="0"
            y1="0"
            x2="0"
            y2="-9"
            stroke="#000080"
            strokeWidth="0.6"
            transform={`rotate(${deg})`}
          />
        ))}
      </g>
    </svg>
  );
}
